import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './RicordiPage.css';
import { API_BASE_URL, getApiHeaders } from '../config/api';
import MemoryCartelleView from './ricordi/MemoryCartelleView';
import SemanticMapView from './ricordi/SemanticMapView';

const RicordiPage = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('cartelle');
  const [categories, setCategories] = useState([]);
  const [photos, setPhotos] = useState([]);
  const [connections, setConnections] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [expandedCategories, setExpandedCategories] = useState([]);
  const [selectedPhotoCategory, setSelectedPhotoCategory] = useState('all');

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      const catResponse = await fetch(`${API_BASE_URL}/api/memories/categories`, { headers: getApiHeaders() });
      const catData = await catResponse.json();
      if (catData.success) {
        setCategories(catData.categories || []);
      }

      const photoResponse = await fetch(`${API_BASE_URL}/api/memories/photos`, { headers: getApiHeaders() });
      const photoData = await photoResponse.json();
      if (photoData.success) {
        setPhotos(photoData.photos || []);
      }

      const connResponse = await fetch(`${API_BASE_URL}/api/memories/connections`, { headers: getApiHeaders() });
      const connData = await connResponse.json();
      if (connData.success) {
        setConnections(connData.connections || []);
      }
    } catch (error) {
      console.error('Errore caricamento dati:', error);
    }
  };

  const handleEditItem = (item) => {
    setSelectedItem(item);
    setShowModal(true);
  };

  const handleSaveItem = () => {
    setShowModal(false);
    setSelectedItem(null);
  };

  const handleDeleteItem = () => {
    setShowModal(false);
    setSelectedItem(null);
  };

  const getPhotoDistribution = () => {
    const distribution = {};
    photos.forEach(photo => {
      distribution[photo.category] = (distribution[photo.category] || 0) + 1;
    });
    return distribution;
  };

  const filteredPhotos = selectedPhotoCategory === 'all'
    ? photos
    : photos.filter(p => p.category === selectedPhotoCategory);

  const photoDistribution = getPhotoDistribution();
  const totalPhotos = photos.length;

  const allMemories = categories.flatMap(cat =>
    (cat.items || []).map(item => ({
      ...item,
      category: cat.name
    }))
  );

  return (
    <div className="ricordi-page">
      <div className="ricordi-header">
        <div className="header-content">
          <h1>Ricordi</h1>
          <p>Esplora i tuoi ricordi organizzati per categoria</p>
        </div>
        <div className="header-stats">
          <div className="stat-item">
            <span className="stat-value">{categories.reduce((sum, cat) => sum + cat.count, 0)}</span>
            <span className="stat-label">Ricordi totali</span>
          </div>
          <div className="stat-item">
            <span className="stat-value">{photos.length}</span>
            <span className="stat-label">Foto</span>
          </div>
          <div className="stat-item">
            <span className="stat-value">{connections.length}</span>
            <span className="stat-label">Connessioni</span>
          </div>
        </div>
      </div>

      <div className="ricordi-tabs">
        <button className={`tab ${activeTab === 'cartelle' ? 'active' : ''}`} onClick={() => setActiveTab('cartelle')}>Cartelle</button>
        <button className={`tab ${activeTab === 'foto' ? 'active' : ''}`} onClick={() => setActiveTab('foto')}>Foto</button>
        <button className={`tab ${activeTab === 'mappa' ? 'active' : ''}`} onClick={() => setActiveTab('mappa')}>Mappa</button>
      </div>

      <div className="ricordi-content">
        {activeTab === 'cartelle' && <MemoryCartelleView memories={allMemories} onEdit={handleEditItem} />}
        {activeTab === 'foto' && <div>Foto view</div>}
        {activeTab === 'mappa' && <SemanticMapView categories={categories} memories={allMemories} />}
      </div>

      {showModal && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal-content" onClick={e => e.stopPropagation()}>
            <h2>Dettagli</h2>
            <pre>{JSON.stringify(selectedItem, null, 2)}</pre>
            <button onClick={() => setShowModal(false)}>Chiudi</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default RicordiPage;
